import { render, staticRenderFns } from "./LandingForm.vue?vue&type=template&id=042b37ba&scoped=true&"
import script from "./LandingForm.vue?vue&type=script&lang=ts&"
export * from "./LandingForm.vue?vue&type=script&lang=ts&"
import style0 from "./LandingForm.vue?vue&type=style&index=0&id=042b37ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b37ba",
  null
  
)

export default component.exports